/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHomePageBannerData } from './home-page-banner.data';
import { IHomePageBannerProps } from './home-page-banner.props.autogenerated';

export interface IHomePageBannerViewProps extends IHomePageBannerProps<IHomePageBannerData> {}

/**
 *
 * HomePageBanner component
 * @extends {React.PureComponent<IHomePageBannerProps<IHomePageBannerData>>}
 */
class HomePageBanner extends React.PureComponent<IHomePageBannerProps<IHomePageBannerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default HomePageBanner;
